import apiClient from '../client';
import type { Class, CreateClassPayload, UpdateClassPayload } from '@/types';

export const classesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Class[] }>('/classes', { params }).then((r) => r.data.data),

  /**
   * Returns a deduplicated list of class name strings for a branch.
   * Uses ?distinct=true — collapses multiple session rows into one per name.
   */
  listNames: (branchSlug?: string): Promise<string[]> =>
    apiClient
      .get<{ data: string[] }>('/classes', { params: { distinct: true, branch_slug: branchSlug || undefined } })
      .then((r) => r.data.data),

  /**
   * Returns canonical {id, name} objects for a branch — one entry per class name.
   * Uses MIN(id) on the backend, so session duplicates are collapsed.
   * Use this whenever you need class_id as the selected value (filters, form fields).
   */
  listForDropdown: (branchSlug?: string): Promise<{ id: number; name: string }[]> =>
    apiClient
      .get<{ data: { id: number; name: string }[] }>('/classes', {
        params: { dropdown: true, branch_slug: branchSlug || undefined },
      })
      .then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: Class }>(`/classes/${id}`).then((r) => r.data.data),

  create: (payload: CreateClassPayload) =>
    apiClient.post<{ data: Class }>('/classes', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateClassPayload) =>
    apiClient.put<{ data: Class }>(`/classes/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/classes/${id}`),
};

